import { alpha, createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';

export const theme = createTheme({
  palette,
  typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1368,
      xl: 1680,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          maxWidth: '1368px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          minHeight: '48px',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FF5A00',
            borderWidth: '1px',
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DC0000',
            borderWidth: '1px',
          },
          '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FF5A00',
          },
          '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DC0000',
          },
        },
        input: {
          padding: '12px 16px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '12px 16px',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          fontWeight: 600,
        },
        contained: {
          backgroundColor: '#FF5A00',
          color: '#fff',
          fontSize: '18px',
          lineHeight: '150%',
          letterSpacing: 0,
          '&:hover': {
            backgroundColor: '#F1F1F1',
            color: '#FF5A00',
          },
          '&:active': {
            backgroundColor: '#E05200',
          },
          '&.Mui-disabled': {
            backgroundColor: alpha('#FF5A00', 0.5),
            color: '#fff',
          },
        },
        outlined: {
          borderColor: '#434343',
          color: '#000',
          '&:hover': {
            borderColor: '#898989',
            color: '#898989',
            backgroundColor: 'transparent',
          },
          '&:active': {
            borderColor: '#FF5A00',
            color: '#FF5A00',
          },
          '&.Mui-disabled': {
            borderColor: alpha('#434343', 0.3),
            color: alpha('#000', 0.3),
          },
        },
        text: {
          color: '#FF5A00',
          '&:hover': {
            color: alpha('#FF5A00', 0.7),
            backgroundColor: 'transparent',
          },
          '&.Mui-disabled': {
            color: '#898989',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#434343',
          '&.Mui-checked': {
            color: '#FF5A00',
          },
          '&.Mui-disabled': {
            color: alpha('#434343', 0.3),
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#434343',
          '&.Mui-checked': {
            color: '#FF5A00',
          },
          '&.Mui-disabled': {
            color: alpha('#434343', 0.3),
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '100px',
          fontWeight: 400,
          '&:hover': {
            borderColor: '#000',
          },
          '&.Mui-disabled': {
            opacity: 0.4,
          },
        },
        outlined: {
          borderColor: '#898989',
          color: '#000',
          backgroundColor: '#fff',
        },
      },
    },
  },
});
